import moment from "moment";
import StatusBadge from "../../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const totalfiles = [
  {
    title: "File Name",
    dataIndex: "service_name_slug",
    render: (value) => <p className="capitalize">{value}</p>,
    width: 250
  },
  {
    title: "File Number",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "E-File Ack No",
    dataIndex: "acknowledge_ment_no",
    render: defaultRender,
  },
  {
    title: "E-File Ack Doc",
    dataIndex: "acknowledgement_doc",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
    width : 330
  },
  {
    title: "Now Processing",
    dataIndex: "running_task_name",
    render: defaultRender,
  },
  {
    title: "Progress",
    dataIndex: "progress",
    render: defaultRender,
    width: 300,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => <StatusBadge status={value} />,
  },
];

export default totalfiles;
